__turbopack_context__.v({
  "blocksBackgroundColor": "EditableFieldStyles-module-scss-module__aMhksq__blocksBackgroundColor",
  "blocksFontColor": "EditableFieldStyles-module-scss-module__aMhksq__blocksFontColor",
  "buttonContainer": "EditableFieldStyles-module-scss-module__aMhksq__buttonContainer",
  "editableTrigger": "EditableFieldStyles-module-scss-module__aMhksq__editableTrigger",
  "editing": "EditableFieldStyles-module-scss-module__aMhksq__editing",
  "editingFullWidth": "EditableFieldStyles-module-scss-module__aMhksq__editingFullWidth",
  "secondaryNavBackgroundColor": "EditableFieldStyles-module-scss-module__aMhksq__secondaryNavBackgroundColor",
  "themeBackgroundColor": "EditableFieldStyles-module-scss-module__aMhksq__themeBackgroundColor",
  "themeFontColor": "EditableFieldStyles-module-scss-module__aMhksq__themeFontColor",
  "themeFontFamily": "EditableFieldStyles-module-scss-module__aMhksq__themeFontFamily",
});
